import styled from 'styled-components'
import { height } from 'styled-system'

const Spacer = styled.div`
    ${height}
`

export default Spacer


// WEBPACK FOOTER //
// ./src/components/Common/Spacer.js